import React from "react";
import Mission from "../components/sections/Mission";

const PhilosophyPage = () => (
  <main className="pt-24 pb-10 min-h-screen" data-testid="philosophy-page">
    <Mission />
  </main>
);

export default PhilosophyPage;
